import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import Layout from '@src/pages/layout'
import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import OrderDetails from '@src/quince-site-integrated/src/integrations/post-order-web/order-details'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

export const getServerSideProps = (async ctx => {
  const pathName = PAGE_PATH.MY_ORDERS_RETURNS

  const serverSideBaseProps = await getServerSideBaseProps(ctx, pathName)
  if ('props' in serverSideBaseProps) {
    const props = await serverSideBaseProps.props
    return {
      props: {
        ...props,
        orderId: ctx.params?.orderId as string,
      },
    }
  }
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageOrderDetails(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const { orderId, pageData, ...layoutProps } = props
  return (
    <Layout pageData={pageData} {...layoutProps}>
      {pageData ? <OrderDetails orderId={orderId} data={pageData} /> : <SomethingWentWrong />}
    </Layout>
  )
}
